import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import Users from './users';
import Orders from './orders';
import App from './app';
import Login from './login';
import ForgotPassword from './forgotPassword';
import Registration from './registration';
import PrivateRoute from './RouteHandler/PrivateRoute';
import UpdatePassword from './updatePassword';
import UserApproval from './userApproval';
import BulkUpload from './bulkUpload';
import PublicRoute from './RouteHandler/PublicRoute';

const Routes = () => (
  <BrowserRouter>
    <App>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/orders" />} />
        <PrivateRoute exact path="/orders" component={Orders} />
        <PrivateRoute exact path="/users" component={Users} />
        <PrivateRoute exact path="/users/:userId" component={Users} />
        <PublicRoute path="/forgot-password" component={ForgotPassword} />
        <PublicRoute path="/update-password" component={UpdatePassword} />
        <PrivateRoute path="/bulk-upload" component={BulkUpload} />
        <Route path="/confirmation" component={UserApproval} />
        <PublicRoute path="/registration" component={Registration} />
        <PublicRoute path="/login" component={Login} />
      </Switch>
    </App>
  </BrowserRouter>
);

export default Routes;
